import { render, staticRenderFns } from "./MbDecisionTree.vue?vue&type=template&id=17b725e4&scoped=true&"
import script from "./MbDecisionTree.vue?vue&type=script&lang=js&"
export * from "./MbDecisionTree.vue?vue&type=script&lang=js&"
import style0 from "./MbDecisionTree.vue?vue&type=style&index=0&id=17b725e4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b725e4",
  null
  
)

export default component.exports